import script from "./DemoControl.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoControl.vue?vue&type=script&setup=true&lang=js"

import "./DemoControl.vue?vue&type=style&index=0&id=7cbdf10d&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cbdf10d"]])

export default __exports__